module.exports = __webpack_public_path__ + "fonts/Inter-Medium-slnt=0.18b8c68.ttf";